export const isScrollOnBottom = (containerElement: HTMLUListElement) => {
  if (!containerElement) {
    return false;
  }

  return containerElement.scrollHeight === Math.ceil(containerElement.scrollTop + containerElement.clientHeight);
};
